import { jsx as _jsx } from "react/jsx-runtime";
import { Drawer as MuiDrawer, } from '@mui/material';
export function Drawer({ children, ...props }) {
    return _jsx(MuiDrawer, { ...props, children: children });
}
